import React, { useEffect } from "react";
import Header from "components/Header/Header.js";
import HeaderLinks from "components/Header/HeaderLinks.js";
import Layout from "./Layout";
import customerDetailsStyles from "assets/jss/material-kit-pro-react/views/cspDashboard/customerDetailsStyles.js";
import { makeStyles } from "@material-ui/core";
import classNames from "classnames";
import Invoice from "./Sections/Component/Invoice";
import AllTransactions from "./Sections/Component/AllTransactions";
import AccountSummary from "./Sections/Component/AccountSummary";
import CustomerList from "./Sections/Component/CustomerList";

const useStylesCustomerDetailsStyles = makeStyles(customerDetailsStyles);

export default function InvoicesPage() {
	const classesCSStyles = useStylesCustomerDetailsStyles();

	useEffect(() => {
		window.scrollTo(0, 0);
		document.body.scrollTop = 0;
		return function cleanup() {};
	}, []);

	return (
		<div>
			{/* <Header
				brand="Transparent"
				color="transparent"
				links={<HeaderLinks dropdownHoverColor="info" />}
				fixed
			/> */}
			<Layout>
				<div className={classNames(classesCSStyles.py5)}>
					<div className={classNames("flex")}>
						<div className={classNames(classesCSStyles.leftSide)}>
							<CustomerList />
						</div>
						<div className={classNames(classesCSStyles.rightSide)}>
							<div className={classNames(classesCSStyles?.my10)}></div>
							<AccountSummary />
							<Invoice />
							<div className={classNames(classesCSStyles?.my10)}></div>
							<AllTransactions />
						</div>
					</div>
				</div>
			</Layout>
		</div>
	);
}
